import React, { useRef, useEffect } from 'react';
import styles from './GlowOnVisible.module.css';

const GlowOnVisible = ({ children, root = null, threshold = 0.1, rootMargin = '0px' }) => {
    const ref = useRef(null);

    useEffect(() => {
        if (!ref.current) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    ref.current.classList.add(styles.active);
                    observer.disconnect();
                }
            },
            { root, threshold, rootMargin }
        );

        observer.observe(ref.current);
        return () => observer.disconnect();
    }, [root, threshold, rootMargin]);

    return <div ref={ref} className={styles.glow}>{children}</div>;
};

export default GlowOnVisible;
